// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"merge-code-container__visuallyhidden--1Gi0m","focusable":"merge-code-container__focusable--hmzl6","container":"merge-code-container__container--YaQIn"};